import { useQuery } from '@apollo/client';
import { useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import useUser from '../../../../../helpers/useUser';
import { READ_SIMULATION_FOR_SELECT } from './SelectSimulation.query';
import Select from '../../Select';
import _ from 'lodash';
import { useSelectFilter } from '../../helpers/useSelectFilter';

export const SelectSimulation = ({ options, loading, ...props }) => {
  const { OrganisationID } = useUser();
  const [filter, filterProps] = useSelectFilter();

  const { data: simData, loading: simLoading } = useQuery(
    READ_SIMULATION_FOR_SELECT,
    {
      variables: {
        OrganisationID,
        filter,
      },
    }
  );

  const sims = useMemo(() => {
    if (!simData) {
      return [];
    }
    return simData.readSimulations.edges.map(({ node }) => ({
      value: node.ID,
      label: node.Title,
    }));
  }, [simData]);

  useEffect(() => {
    const { inputValue, ref } = filterProps;
    if (!simLoading && inputValue) {
      ref.current.focus();
      ref.current.onMenuOpen();
    }
    // I do not want this to activate with inputValue change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [simLoading]);

  const allOptions = useMemo(() => [...options, ...sims], [options, sims]);

  return (
    <Select
      {...props}
      {...filterProps}
      options={allOptions}
      loading={simLoading || loading}
    />
  );
};

SelectSimulation.defaultProps = {
  options: [],
  loading: false,
};

SelectSimulation.propTypes = {
  options: PropTypes.arrayOf(PropTypes.any),
  loading: PropTypes.bool,
};

export default SelectSimulation;
